/**
 * Shared conflict-badge list rendered by both the desktop Conflict column
 * (RowTableUpdateCells) and the mobile card footer (UpdateRowFooter).
 * Returns null when there are no conflicting properties.
 */

import { AlertTriangle } from '@untitledui/icons';

import { Badge } from '@/lib/base/badges/badges';
import type { PropertySchemaMap } from '@/lib/crm/hooks/usePropertySchema';

import { getPropertyLabel } from './types';

export interface ConflictBadgeListProps {
  conflictingProperties: string[];
  schemaMap: PropertySchemaMap;
  newPropertyLabels: Record<string, string>;
}

export function ConflictBadgeList({
  conflictingProperties,
  schemaMap,
  newPropertyLabels,
}: ConflictBadgeListProps) {
  if (conflictingProperties.length === 0) {
    return null;
  }
  return (
    <>
      {conflictingProperties.map(property => (
        <Badge key={property} color='warning' size='sm' className='gap-1'>
          <AlertTriangle aria-hidden={true} className='w-3 h-3' />
          {getPropertyLabel(property, schemaMap, newPropertyLabels)}
        </Badge>
      ))}
    </>
  );
}
